import type {
  IUserCurrentSaveBody,
  IUserCurrentSaveResponse,
} from '@/app-package';

import axios from 'axios';

const currentSave = async (user: IUserCurrentSaveBody) => {
  const url = '/user/current';

  const { data } = await axios.post<IUserCurrentSaveResponse>(url, user);

  return data;
};

export default currentSave;
